import { Box, Button, Divider, ModalBody, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Alert, Form, Modal, Profile, Show } from "components";
import { Mask } from "config";
import { API } from "config";
import { useConsultant } from "hooks";
import { useEffect, useState } from "react";
import { Authenticate } from "screens";

export default function Migrate({ data, ...props }){

    const consultant = useConsultant(data?.id)
    const toast = useToast()
    const auth = useDisclosure()
    const [ loading, setLoading ] = useState(false)
    const [ upline_cpf, setUplineCpf ] = useState()
    const [ upline, setUpline ] = useState()

    const handleSearchCpf = async () => {
        setLoading('search')
        setUpline(null)

        try{
            const callback = await API.get(`/consultants/list?term=${Mask.digit(upline_cpf)}`)
            const result = callback.data?.data?.[0]

            if(!result){ toast({ title: 'O consultor informado não foi encontrado.', status: 'warning'}); }

            if(result){
                setUpline(result?.customer)
            }
            
        }catch(err){
            toast({ title: 'Não foi encontrado um consultor com este CPF.', description: err?.response?.data?.message, status: 'warning'})
        }

        setLoading(false)
    }

    const handleSubmit = async () => {
        setLoading('submit')

        try{
            await API.post(`/consultants/${data?.id}/migrate`, { upline_cpf, method: 1 })
            props.onClose()
            consultant.refetch()
        }catch(err){
            toast({ title: 'Não foi possível realizar a migração agora.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    useEffect(() => {
        if(upline_cpf?.length === 14) handleSearchCpf()
    }, [upline_cpf])

    return(
    <Modal title="Migração de rede" loading={loading} size="lg" {...props}>
        <ModalBody>
            <Stack spacing={6}>

                <Alert size="sm" status="warning">Ao alterar o upline de um consultor, toda a rede abaixo dele também será migrada junto. Esta ação é irreversível!</Alert>
                
                <Form.Text 
                    required
                    label="CPF do novo Upline:"
                    name="upline_cpf"
                    helper={`Digite ou cole o número do documento CPF de quem será o upline de. ${data?.customer?.name}`}
                    placeholder="Ex.: 849.483.908-84"
                    value={upline_cpf}
                    onChange={e => setUplineCpf(Mask.cpf(e.target.value))}
                    size="lg"
                    isDisabled={!!loading}
                />

                <Show visible={loading==='search'}><Alert>Buscando consultor...</Alert></Show>

                <Show visible={!!upline}>

                    <Stack spacing={4} p={4}>
                        <Text fontSize="sm" color="GrayText">Atual upline de <b>{data?.customer?.name}</b>:</Text>
                        <Text><Profile size="sm" name={data?.upline?.customer?.name ?? 'Usuário Expirado'} src={data?.upline?.customer?.avatar_url} /></Text>
                        <Divider />
                        <Text fontSize="sm" color="GrayText">Migrando para o upline:</Text>
                        <Profile size="sm" name={upline?.name} src={upline?.avatar_url} />
                    </Stack>

                </Show>

                <Button colorScheme="red" isLoading={loading==='submit'} loadingText="Migrando rede..." isDisabled={!!loading || !upline} onClick={auth.onOpen}>⚠️ Realizar migração de rede</Button>
            </Stack>
        </ModalBody>

        <Authenticate {...auth} onSuccess={handleSubmit} />
    </Modal>
    )
}